var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application-layout",attrs:{"id":"application-layout"}},[(!_vm.isGuestLoginEnabled)?_c('site-header'):_vm._e(),_c('environment-alert'),_c('main',{staticClass:"main-content d-flex flex-column align-items-center justify-content-center"},[_c('router-view')],1),(!_vm.isGuestLoginEnabled)?_c('site-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }